import axios from 'axios'
import { baseUrl } from "@/config"
import { getSignature } from '@/utils/crypto'
import md5 from "js-md5";
// 创建axios实例
const http = axios.create({
  baseURL: baseUrl,
  timeout: 10000
})

let handling401 = false

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 添加认证头
    //api防御
    const ts = Math.floor(Date.now() / 1000)
    const content = md5(location.host+Math.random().toString())
    const sign_result =getSignature(ts,content);
    if(ts&&content&&sign_result){
      config.headers["X-CDN-TIMESTAMP"] = ts;
      config.headers["X-CDN-VERIFY-CONTENT"] = content;
      config.headers["X-CDN-SIGNATURE"] = sign_result;
    }
    const authToken = localStorage.getItem('auth_token')
    if (authToken) {
      config.headers['x-auth-token'] = authToken
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        if (!handling401) {
          handling401 = true
          try {
            const wss = typeof window !== 'undefined' ? window.wsService : null
            if (wss && typeof wss.invalidateAuth === 'function') {
              wss.invalidateAuth()
            } else if (wss && typeof wss.disconnect === 'function') {
              wss.disconnect()
            }
          } catch (e) {
            console.error(e)
          }
          setTimeout(() => {
            handling401 = false
          }, 1000)
        }
        // 认证失败，清除本地存储并跳转到登录页
        localStorage.removeItem('auth_token')
        localStorage.removeItem('login_id')
        if (window.location.hash !== '#/login') {
          window.location.hash = '#/login'
        }
      }
    }
    return Promise.reject(error)
  }
)

export default http
